const junoVideo = {
  selection: {
    new: "新モデル",
    popularModel: "人気モデル",
    referenceModel: "参照モデル",
    longModel: "長尺",
    highQualityModel: "高画質",
    lowCostModel: "低コスト",
    highPrecisionModel: "高精度",
    cameraControl: "カメラコントロール",
    trending: "注目",
    fastModel: "高速",
    costEffective: "高コストパフォーマンス",
    popularLipSync: "リップシンク人気",
    imageToVideo: "画像から動画",
    videoEdit: "動画編集",
    upscale: "アップスケール",
    lipsync: "リップシンク",
  },
  title: "VIDEO GENERATOR",
  caution: "Google の提供価格により、VEO2のコストは非常に高くなっています。ご利用の際は注意してください。",
  menu: {
    t2v: "テキストから動画",
    i2v: "画像から動画",
    v2v: "動画から動画",
    library: "ライブラリ",
    upscale: "アップスケール",
    lipsync: "リップシンク",
    reframe: "リフレーム",
  },
  ai: {
    select: "AIモデルを選択してください",
    model: "モデル",
    runway: {
      title: "RunwayML",
      description: "【高速】AIと機械学習を活用して動画制作プロセスを簡素化し、プロから初心者まで幅広いユーザー向け。",
      model: {
        GEN3_ALPHA_TURBO: "Gen3 Alpha Turbo",
        GEN3_ALPHA_TURBO_description: "Runwayの最速モデル。迅速なイテレーションとプレビューに最適。",
        GEN4_TURBO: "Gen4 Turbo",
        GEN4_TURBO_description: "Runwayの最新Gen4モデルで、一貫性と現実感が向上した高品質な動画生成を提供します。",
      },
    },
    kling: {
      title: "KLING AI",
      description: "【低速】KLING AIは、高度な物理シミュレーションと3D技術を活用したリアルで自然な動きの動画を生成。",
      model: {
        V1_0_STANDARD: "v1.0 スタンダード",
        V1_6_STANDARD: "v1.6 スタンダード",
        V1_0_PRO: "v1.0 プロ",
        V1_5_PRO: "v1.5 プロ",
        V1_6_PRO: "v1.6 プロ",
        V1_6_STANDARD_ELEMENTS: "v1.6 スタンダード Elements",
        V1_6_PRO_ELEMENTS: "v1.6 プロ Elements",
        V2_MASTER: "v2.0 マスター",
        V2_1_STANDARD: "v2.1 スタンダード",
        V2_1_PRO: "v2.1 プロ",
        V2_1_MASTER: "v2.1 マスター",
        V1_0_STANDARD_description:
          "KLING初期の基本モデル。720p解像度で最大5秒の動画を生成。物理法則に基づく自然な動きを実現する基礎的な動画生成機能を提供。",
        V1_6_STANDARD_description:
          "KLING第1.6世代の標準モデル。720p解像度で最大10秒の動画生成が可能。初期バージョンから大幅に品質とリアリズムが向上し、プロンプト理解力も強化された実用的モデル。",
        V1_0_PRO_description:
          "初期のKLINGプロモデル。v1.0より高品質で長時間の動画を生成可能。より自然な動きと詳細な表現を実現し、プロフェッショナルな映像制作に対応。",
        V1_5_PRO_description:
          "フルHD 1080p対応の第1.5世代プロモデル。Motion Brush機能（最大6つの要素に個別の動き指定）やCamera Movement機能を搭載。品質とリアリズムが大幅に向上した上位モデル。",
        V1_6_PRO_description:
          "フルHD 1080p対応の最新プロモデル。2024年12月時点で最高レベルの映像品質を実現し、複雑な物理シミュレーションと自然な動きを提供する最も高度なKLINGモデル。",
        V1_6_STANDARD_ELEMENTS_description:
          "3枚の画像を同時入力して複雑なシーン生成が可能なStandardモデル。複数の視点や要素を組み合わせた高度な動画制作に対応し、720p解像度で豊富な表現を実現。",
        V1_6_PRO_ELEMENTS_description:
          "3枚の画像を同時入力して高品質な複雑シーン生成が可能なProモデル。Elementsシリーズの最上位版で1080p解像度での詳細な映像制作を実現する高度なモデル。",
        V2_MASTER_description:
          "KLING第2世代のマスターモデル。v1.6から更なる品質向上と生成効率の改善を実現。より高度な物理シミュレーションと自然な動きを提供する次世代モデル。",
        V2_1_STANDARD_description:
          "最新のKLING v2.1スタンダードモデル。高速生成と優れた品質を実現。v2.0より処理速度が向上し、より手軽に高品質動画を生成できる最新の標準モデル。",
        V2_1_PRO_description:
          "最新のKLING v2.1プロモデル。v2.1スタンダードより高品質で詳細な動画を生成。プロフェッショナル用途に適した最高レベルの映像品質を提供する上位モデル。",
        V2_1_MASTER_description:
          "最新のKLING v2.1マスターモデル。KLINGシリーズの最上位版で最高品質と精度を提供。映画制作レベルの品質を実現する最先端の動画生成モデル。",
      },
    },
    luma: {
      title: "Luma",
      description: "【高速】Luma Rayは、テキストや画像から高品質でリアルな動画を生成するAIモデル。",
      model: {
        V1_5: "Ray 1.5",
        RAY_1_6: "Ray 1.6",
        RAY_2: "RAY 2",
        RAY_2_1080P: "RAY 2 1080P",
        RAY_2_4K: "RAY 2 4K",
        V1_5_description:
          "Dream Machineの初期の安定モデル。品質と生成速度のバランスが取れており、24fps×5秒の120フレーム動画を生成。基本的な動画生成機能を提供する基礎モデル。",
        RAY_1_6_description:
          "Rayの改良版でカメラモーション機能を搭載。テキスト入力でカメラワーク（ズーム、パン等）の指示が可能。大幅な高速化により短時間での動画生成を実現した実用的モデル。",
        RAY_2_description:
          "Ray1.6の10倍の計算処理能力を持つ革新的モデル。より高速で自然な動き、超リアルな細部表現、論理的なイベント展開を実現。動画生成成功率が大幅向上した次世代モデル。",
        RAY_2_1080P_description:
          "RAY 2の1080p解像度版。4K画質へのアップスケール機能も搭載。最大10秒の動画生成が可能で、プロフェッショナル品質の映像制作に対応した高画質モデル。",
        RAY_2_4K_description:
          "RAY 2の4K解像度対応版。最高画質での動画生成が可能で、大画面表示や高精細映像制作に最適。最大の品質と詳細さを提供する最上位解像度モデル。",
        RAY_2_FLASH: "RAY 2 Flash",
        RAY_2_FLASH_description:
          "RAY 2の高速化版。品質を維持しながら大幅な速度向上を実現した実用的なモデル。効率的な動画生成で多量のコンテンツ制作に適している。",
        RAY_2_FLASH_1080P: "RAY 2 Flash 1080P",
        RAY_2_FLASH_1080P_description:
          "RAY 2 Flashの1080p解像度版。高速生成と高画質を両立し、効率的な高品質動画制作を可能にする実用性の高いモデル。",
        RAY_2_FLASH_4K: "RAY 2 Flash 4K",
        RAY_2_FLASH_4K_description:
          "RAY 2 Flashの4K解像度版。高速生成ながら超高精細な出力が可能。高速処理と最高画質を両立した革新的なモデル。",
        RAY_2_REFRAME: "RAY 2 Reframe",
        RAY_2_REFRAME_description:
          "アスペクト比変更に特化したRAY 2モデル。既存動画の縦横比を自然に変換し、異なるプラットフォーム向けのコンテンツ制作を効率化するリフレーム専用モデル。",
        RAY_2_FLASH_REFRAME: "RAY 2 Flash Reframe",
        RAY_2_FLASH_REFRAME_description:
          "高速でアスペクト比変更が可能なモデル。複数のSNSプラットフォーム向けに動画を効率的に最適化できる実用的なリフレームツール。",
      },
    },
    hailuo: {
      title: "Minimax",
      description: "【低速】Hailuo AI/Minimaxは、高品質な動画生成と人物の動きの正確な再現に優れているとされています。",
      model: {
        MINI_MAX: "VIDEO-01",
        MINI_MAX_LIVE: "VIDEO-01-LIVE",
        MINI_MAX_REF: "VIDEO-01-SUBJECT-REFFRENCE",
        MINI_MAX_DIRECTOR: "VIDEO-01-DIRECTOR",
        MINI_MAX_description:
          "MiniMaxの標準動画生成モデル。720p解像度・25fpsで最大6秒の高品質動画を生成。テキストまたは画像からの動画生成に対応し、人物の動きを正確に再現する基礎モデル。",
        MINI_MAX_LIVE_description:
          "2Dアニメーションスタイルに最適化されたモデル。アニメキャラクターや2Dイラストを自然に動かすことに特化し、アニメーション制作に最適な動画を生成するスタイル特化型モデル。",
        MINI_MAX_REF_description:
          "被写体参照機能を持つモデル。特定のキャラクターや人物の一貫性を保ちながら動画を生成可能。キャラクター設定を維持した連続的な動画制作に対応する参照型モデル。",
        MINI_MAX_DIRECTOR_description:
          "詳細なカメラコントロールが可能な上位モデル。映画的なカメラワーク、アングル変更、複雑な演出指示に対応し、プロフェッショナルな映像制作を実現する監督機能付きモデル。",
      },
    },
    haiper: {
      title: "Haiper AI",
      description: "【低速】Haiper AIは、日本人の顔やポーズを自然に再現する能力に優れています",
      model: {
        V2_0: "Haiper V2.0",
        V2_5: "Haiper V2.5",
        V2_0_description:
          "Haiperの第2世代モデル。深層学習アルゴリズムを新たに採用し、人物の動きや表情がより自然になったバージョン。6秒固定の動画生成でテンプレート機能を搭載した基礎モデル。",
        V2_5_description:
          "V2.0の改良版で動きがより滑らかで自然に進化。特に日本人を含むアジア系の顔の表情や自然なポーズの再現において優れた性能を発揮する高度化されたモデル。",
      },
    },
    pixverse: {
      title: "PixVerse",
      description: "【高速】PixVerseは、高品質な動画生成AIで、テキストや画像から自然な動きの動画を生成します",
      model: {
        V3_5: "V3.5",
        V3_5_1080P: "V3.5 1080P",
        V3_5_FAST: "V3.5 Peformance",
        V3_5_description:
          "720p解像度での高品質動画生成モデル。10秒以下の超高速生成を実現し、アニメスタイルが強化された。Start/End Frame機能で動画の開始・終了シーンの制御が可能な効率型モデル。",
        V3_5_1080P_description:
          "V3.5の1080p解像度版。より高品質な映像出力が可能で、プロフェッショナルユースにも対応できる鮮明で詳細な動画を生成する高画質モデル。",
        V3_5_FAST_description:
          "V3.5の高速最適化版。アクションシーンや動きの多い場面に特化し、ダイナミックで活発な動きを高速で表現できるパフォーマンス重視の実用的モデル。",
        V3_5_TRANSITION: "V3.5 Transition",
        V3_5_TRANSITION_1080P: "V3.5 Transition 1080P",
        V4: "V4",
        V4_1080P: "V4 1080P",
        V4_FAST: "V4 Performance",
        V4_5: "V4.5",
        V4_5_1080P: "V4.5 1080P",
        V4_5_FAST: "V4.5 Performance",
        V4_5_TRANSITION: "V4.5 Transition",
        V4_5_TRANSITION_1080P: "V4.5 Transition 1080P",
        V3_5_TRANSITION_description:
          "二枚の画像間を自然にトランジションする動画を生成。720p解像度で滑らかな画像遷移を実現し、ストーリー制作やプレゼンテーションに最適な画像間遷移専用モデル。",
        V3_5_TRANSITION_1080P_description:
          "V3.5 Transitionの1080p高画質版。より鮮明で詳細な画像間遷移動画を生成し、プロフェッショナルな映像制作に対応する高画質トランジションモデル。",
        V4_description:
          "720p解像度のPixVerse最新モデル。V3.5から大幅な品質向上を実現し、音声同期機能も新たに追加。より自然で滑らかな動きを生成可能な第4世代基本モデル。",
        V4_1080P_description:
          "V4の1080p解像度版。高解像度での詳細な映像表現が可能で、音声機能と組み合わせてプロレベルの動画制作を実現する高画質第4世代モデル。",
        V4_FAST_description:
          "V4の高速処理最適化版。720p解像度で処理時間を大幅短縮しながら、V4品質を維持した効率的な動画生成を提供するパフォーマンス特化モデル。",
        V4_5_description:
          "PixVerse最新の720p動画生成モデル。20以上の映画レンズ効果、複数画像融合機能を搭載し、ハリウッド級の映像表現を実現する革新的第4.5世代モデル。",
        V4_5_1080P_description:
          "V4.5の1080p高画質版。映画品質のレンズコントロールと高解像度を組み合わせ、プロフェッショナルな映像制作に最適な最上位第4.5世代モデル。",
        V4_5_FAST_description:
          "V4.5の高速処理版。720p解像度で映画品質の機能を高速生成。速度と品質のバランスが最適化されたビジネス用途向けパフォーマンスモデル。",
        V4_5_TRANSITION_description:
          "V4.5品質で二枚の画像をスムーズに遷移。720p解像度で映画レベルの画像間トランジション効果を実現する高度な第4.5世代遷移モデル。",
        V4_5_TRANSITION_1080P_description:
          "V4.5 Transitionの1080p版。映画品質のレンズ効果を使った高解像度画像遷移動画を生成し、最高レベルの映像表現を提供する最上位遷移モデル。",
        V4_T2V_description:
          "テキストから動画生成に特化したV4モデル。720p解像度でテキストプロンプトの理解力が最適化され、より正確な動画生成を実現するテキスト特化型モデル。",
        V4_T2V_1080P_description:
          "テキスト生成特化V4モデルの1080p版。高解像度でテキストプロンプトを忠実に再現した高品質動画を生成可能なテキスト生成高画質モデル。",
        V4_T2V_FAST_description:
          "テキスト生成に特化したV4高速版。720p解像度でテキストプロンプトからの動画生成を効率的に実行するテキスト生成パフォーマンスモデル。",
      },
      style: {
        default: "デフォルト",
        anime: "アニメ",
        "3d_animation": "3Dアニメーション",
        clay: "クレイアート",
        comic: "コミック",
        cyberpunk: "サイバーパンク",
      },
    },
    vidu: {
      title: "Vidu",
      description: "【高速】Viduは、テキストや画像から高品質な動画を生成するAIモデルです。",
      model: {
        VIDU_2_0_720P: "Vidu v2.0 720P",
        VIDU_2_0_1080P: "Vidu v2.0 1080P",
        VIDU_2_0_REF_720P: "Vidu v2.0 Reference",
        VIDU_2_0_START_END_720P: "Vidu v2.0 Start-End 720P",
        VIDU_2_0_START_END_1080P: "Vidu v2.0 Start-End 1080P",
        VIDU_Q1: "Vidu Q1",
        VIDU_Q1_START_END: "Vidu Q1 Start-End",
        VIDU_2_0_720P_description:
          "Vidu第2世代の720p標準モデル。高速生成と安定した品質を実現し、効率的な動画制作が可能。テキストと画像の両方の入力に対応した基本モデル。",
        VIDU_2_0_1080P_description:
          "Vidu v2.0の1080p高画質版。より詳細で鮮明な映像出力が可能で、プロフェッショナルな用途にも対応できる高品質動画を生成する上位モデル。",
        VIDU_2_0_REF_720P_description:
          "最大3枚の参照画像を組み合わせて理想的な動画を生成。複数の要素を統合した複雑なシーン制作が可能な高度な機能を持つ参照型モデル。",
        VIDU_2_0_START_END_720P_description:
          "開始画像と終了画像を指定して720p動画を生成。二つのシーン間をスムーズに遷移させる高精度のトランジション機能を搭載したキーフレーム制御モデル。",
        VIDU_2_0_START_END_1080P_description:
          "Start-End機能の1080p高画質版。開始・終了画像間の高解像度遷移動画を生成し、プロレベルのトランジション効果を実現する高画質キーフレームモデル。",
        VIDU_Q1_description:
          "Viduの高性能Q1モデル。画像から動画への変換に特化し、静止画像に自然で滑らかな動きを付加する専門的な機能を提供する画像アニメーション特化型モデル。",
        VIDU_Q1_START_END_description:
          "Q1モデルのStart-End機能版。開始・終了画像を指定した高品質トランジション動画を生成し、映像編集の効率化を実現するキーフレーム対応高性能モデル。",
      },
      movement: {
        auto: "自動",
        small: "小",
        medium: "中",
        large: "大",
      },
      style: {
        general: "一般",
        anime: "アニメ",
      },
    },
    bytedance: {
      title: "ByteDance",
      description: "【高速】ByteDanceは、動画と音声を組み合わせて自然な動きを生成するAIモデルです。",
      model: {
        LATENTSYNC: "LantentSync",
        LATENTSYNC_description:
          "ByteDanceが開発したStable Diffusion基盤の高精度リップシンクAI。音声に合わせてリアルな口の動きと表情を生成し、時間的一貫性を保った自然なアニメーションを実現するリップシンク専用モデル。",
        SEEDANCE_V1_LITE: "Seedance V1 Lite",
        SEEDANCE_V1_LITE_description:
          "ByteDanceの最新テキスト/画像-動画生成モデル。テキストプロンプトや画像から高品質な動画を生成し、高度なカメラ制御と動きの一貫性を提供する次世代動画生成AI。",
      },
    },
    sync: {
      title: "Sync",
      description: "【高速】Syncは、動画と音声を同期させて自然なリップシンクを生成するAIモデルです。",
      model: {
        LIPSYNC_190: "LipSync v1.9.0 Beta",
        LIPSYNC_190_description:
          "Wav2Lipの開発者が手がける高品質リップシンクモデル。自然な口の動きと表情を生成し、リアルタイム処理にも対応したベータ版の先進的リップシンクモデル。",
        LIPSYNC_V2: "LipSync v2",
        LIPSYNC_V2_description:
          "最新のリップシンクモデル。より高精度な口の動きと表情制御を実現し、プロフェッショナル品質のリップシンクを効率的に生成する第2世代リップシンクモデル。",
      },
    },
    realesrgan: {
      title: "Real-ESRGAN 4K",
      description:
        "画像アップスケールAIで有名なReal-ESRGANの技術を動画に応用し、動画の解像度を向上させ、より鮮明な映像を生成します。",
      model: {
        REALESRGAN: "Real-ESRGAN 4K",
        REALESRGAN_description:
          "画像超解像技術で実績のあるReal-ESRGANを動画に応用した革新的モデル。低解像度動画を4K品質まで高精細化し、ディテールを自然に復元する高度なアップスケール技術を提供する解像度向上専用モデル。",
      },
    },
    google: {
      title: "Google",
      description: "【高速】Googleの動画生成AIです。高いコストがかかりますが、品質と自然な動きを提供します。",
      model: {
        VEO2: "VEO2",
        VEO2_description:
          "GoogleのDeepMindが開発した高性能動画生成AI。最大4K解像度・2分長の動画生成が可能。物理法則と人間の動きを正確に理解し、ハルシネーションの軽減と映画撮影技術用語の理解に対応した先進的モデル。",
        VEO3: "VEO3",
        VEO3_description:
          "VEO2の後継として開発されたGoogleの最新動画生成AI。音声付き動画生成とリップシンク機能を搭載し、8秒の会話・BGM・効果音を含む革新的な動画制作を実現する世界初の音声統合型モデル。",
      },
    },
    wan: {
      title: "Wan",
      description:
        "【中速】Wanは、中国の大手IT企業Alibabaが開発した動画生成AIモデルです。比較的低コストで高精度な動画生成が可能です。",
      model: {
        V2_1: "Wan v2.1 720P",
        V2_1_description:
          "Alibabaが開発したテキスト・画像両対応の最新動画生成モデル。720p解像度で高品質かつ自然な動きの動画を生成。14Bパラメータによる高度な物理シミュレーションを実現する第2.1世代基本モデル。",
        V2_1_PRO: "Wan Pro v2.1 1080P",
        V2_1_PRO_description:
          "Wan v2.1のプロ版で1080p解像度・30FPSに対応。より高精細で滑らかな動画生成が可能で、プロフェッショナル用途に適した高品質第2.1世代上位モデル。",
        FIRST_TO_LAST: "First To Last Frame 720P",
        FIRST_TO_LAST_description:
          "開始フレームと終了フレーム間をスムーズに遷移する専門モデル（FLF2V）。高度なカメラムーブメントをサポートし、映画的なトランジション効果を720p品質で実現するキーフレーム補間特化型モデル。",
      },
    },
    pika: {
      title: "Pika",
      description: "【高速】Pikaは高品質な画像から動画の生成と様々なアスペクト比に対応した動画生成AIモデルです。",
      model: {
        V2_2_720P: "Pika v2.2 720P",
        V2_2_720P_description:
          "Pika最新の720p動画生成モデル。様々なアスペクト比（16:9、9:16、3:4等）に対応し、高品質な画像から動画への変換を効率的に実行。最大10秒の動画生成が可能な最新基本モデル。",
        V2_2_1080P: "Pika v2.2 1080P",
        V2_2_1080P_description:
          "Pika v2.2の1080p高画質版。より鮮明で詳細な動画出力が可能で、プロフェッショナルな映像制作にも対応できる高品質な最新上位モデル。",
        V2_2_SCENES_720P: "Pika Scenes v2.2 720P",
        V2_2_SCENES_720P_description:
          "複数の画像から統合されたシーンを生成する専門モデル。720p解像度で複雑な構成の動画制作を可能にする高度な機能を搭載したシーン生成特化型モデル。",
        V2_2_SCENES_1080P: "Pika Scenes v2.2 1080P",
        V2_2_SCENES_1080P_description:
          "Scenes機能の1080p版。複数画像から高解像度でシーン統合された動画を生成し、より詳細で複雑な映像制作を実現するシーン生成高画質モデル。",
        V2_TURBO_720P: "Pika Turbo v2 720P",
        V2_TURBO_720P_description:
          "Pika v2の高速生成に最適化されたTurboモデル。720p品質を維持しながら生成時間を大幅短縮した効率重視の高速生成モデル。",
        V2_SWAPS: "Pika Swaps v2",
        V2_SWAPS_description:
          "既存動画内の特定オブジェクトを別のオブジェクトに置き換える専門機能。動画編集の効率化とクリエイティブな表現を可能にする革新的なオブジェクト入れ替えモデル。",
        V2_ADDITIONS: "Pika Additions v2",
        V2_ADDITIONS_description:
          "既存動画に新しいオブジェクトや要素を自然に追加する機能。既存コンテンツの拡張や修正を効率的に行える動画編集特化のオブジェクト追加モデル。",
      },
    },
    topazlabs: {
      title: "Topaz Labs",
      description:
        "次世代AIを活用した高品質なビデオアップスケーリングとフレームレート補完を提供します。最大4K 60FPSにまで対応。",
      model: {
        TOPAZ_VIDEO_UPSCALE: "Upscale 4K 60FPS",
        TOPAZ_VIDEO_UPSCALE_description:
          "次世代AI技術による高品質ビデオアップスケーリングモデル。低解像度動画を最大4K・60FPSまで向上させ、フレーム補間と画質向上を同時に実現する業界最高水準のアップスケール専用モデル。",
      },
    },
    framepack: {
      title: "FramePack",
      description: "【高速】5〜60秒の高品質な動画を生成できるモデルで、特に限定的な動きのある動画に適しています。",
      model: {
        FRAMEPACK: "Image-to-Video",
        FRAMEPACK_description:
          "5〜60秒の長尺動画生成に特化したモデル。静止画から自然で限定的な動きを持つ高品質動画を生成し、ループ動画や背景動画制作に最適。わずか6GBのVRAMで動作する効率的な長尺動画生成モデル。",
        FRAMEPACK_F1: "F1",
        FRAMEPACK_F1_description:
          "過去フレームから未来フレームを順方向に予測する高度なAIモデル。従来の逆方向生成とは異なり、より大きな分散とダイナミクスを提供し、プロンプトトラベリング（連続的な変化）に最適化された順方向予測特化モデル。",
        FRAMEPACK_FIRST_TO_LAST: "First to Last",
        FRAMEPACK_FIRST_TO_LAST_description:
          "開始画像と終了画像を補間して自然な遷移動画を生成。FramePackの画像間トランジション専門機能で、滑らかな変化を持つ動画制作を実現するキーフレーム補間モデル。",
      },
    },
    hedra: {
      title: "Hedra",
      description: "【高速】Hedraは、リアルな表情と口の動きで高品質な動画を作成するリップシンク専用AIです。",
      model: {
        CHARACTER3: "Character 3",
        CHARACTER3_description:
          "Hedraの最新オムニモーダルモデル。画像・テキスト・音声を統合的に処理し、画像と音声からリアルなリップシンクと自然な表情変化、全身の動きまで再現可能。キャラクターベースの動画制作に特化した第3世代統合型モデル。",
      },
    },
  },
  params: {
    title: "動画設定",
    size: "動画サイズ",
    upload: "画像アップロード",
    uploadFace: "画像アップロード（顔検出）",
    uploadFaceVideo: "動画アップロード（顔検出）",
    uploadVideo: "動画をアップロード",
    generatedVideo: "生成動画から選択",
    generatedAudio: "生成音声から選択",
    video: "動画をアップロード",
    audio: "音声をアップロード",
    duration: "動画の長さ",
    aspect: "アスペクト比",
    aspectTooltip:
      "画像から動画を生成する場合、モデルにより元画像がストレッチ、クロップ、リサイズされることがあります。",
    loop: "ループ",
    loopMode: "ループモード",
    style: "スタイル",
    resolution: "解像度",
    negativePrompt: "ネガティブプロンプト",
    swap: "スワップしたいオブジェクト",
    movement: "動きの激しさ",
    guidanceScale: "ガイダンススケール",
    guidanceScaleHelp: "生成される動画の品質とクリエイティビティのバランスを調整します",
    cameraFixed: "カメラ固定",
    scale: "スケール",
    scaleHelp: "長辺が3840px、短辺が2160pxを超えないように設定してください。",
    syncModel: "リップシンクモデル",
    syncMode: "同期モード",
    pingpong: "ピンポン",
    loopType: "ループ",
    bounce: "バウンス",
    cutOff: "カットオフ",
    lipsync190: "LipSync v1.9.0 Beta",
    lipsync180: "LipSync v1.8.0",
    lipsync171: "LipSync v1.7.1",
    inferenceSteps: "推論ステップ数",
    inferenceStepsHelp: "高いほど高精度で低いほど早い",
    fps: "FPS",
    fpsHelp: "出力動画のフレームレートを設定します",
    generateAudio: "音源を生成 (クレジット変動)",
    input: {
      label: "プロンプト",
      placeholder: "動画のプロンプトを入力してください（英語推奨）",
      notRequired: "このモードではプロンプトは不要です",
      warning: "※ ポリシーに反する動画は生成できず、その際のクレジットは保証されません。",
      error: {
        button: "エラーの原因",
        tooltip:
          "エラーが続く場合、プロバイダー側で障害が発生している可能性が高いです。時間をおいて再度お試しください。",
      },
    },
    submit: "動画を生成",
  },
  myVideo: "マイビデオ",
  processing: "動画生成中...\n通常5分以内に完了します",
  sampleVideo: "サンプル動画",
  sampleVideoDescription:
    "※ サンプルビデオ内の一部の機能はTenak AIではご利用できません。 サンプルビデオは旧モデルの可能性があります。",
  error: {
    generate: "動画の生成に失敗しました。\nポリシー違反がないか確認し、\n時間をおいて再度お試しください。",
    required: {
      image: "画像をアップロードしてください。",
      prompt: "プロンプトを入力してください。",
      onlyLastImage: "画像(FIRST)は必須です。",
      swap: "スワップしたいオブジェクトを入力してください。",
    },
    max: {
      prompt: "プロンプトは512文字以内で入力してください。",
      resolution: "動画の解像度は829万画素（4K相当）以下にしてください。",
      videoSize: "動画のファイルサイズは50MB以下にしてください。",
      smallVideoSize: "動画のファイルサイズは8MB以下にしてください。",
      videoDuration: "動画の長さは{{sec}}秒以下にしてください。",
      audioSize: "音声のファイルサイズは30MB以下にしてください。",
      audioDuration: "音声の長さは60秒以下にしてください。",
      frames: "REALESRGANでは1000フレーム以上の動画は処理できません。",
      reframeDuration: "リフレーム機能では動画の長さは10秒以下にしてください。",
      reframeSize: "リフレーム機能では動画のファイルサイズは100MB以下にしてください。",
    },
    processingLimit:
      "処理中のリクエスト数が上限に達しています。現在{{current}}件のリクエスト（画像と動画の合計）が処理中です。あなたのプランでは最大{{limit}}件の同時リクエストが可能です。",
  },
  reframe: {
    maxDuration: "動画を拡張しアスペクト比を変更: 最大{{duration}}秒、最大{{maxSize}}",
  },
  startGenerating: "動画生成リクエストをキューに追加しました。",
  videoMenu: {
    download: "ダウンロード",
    delete: "削除",
    lastFrame: "最終フレームから生成",
  },
  extend: {
    title: "動画を拡張",
    description: "動画の前後を拡張し、より長い動画を生成します。",
    startFrame: "開始フレーム（オプション）",
    endFrame: "最終フレーム（オプション）",
    sourceVideo: "元の動画",
    continue: "続き方向に拡張",
    before: "前の方向に拡張",
    extendable: "このモデルで生成された動画は拡張機能をサポートしています。",
  },
  message: {
    deleted: "動画を削除しました。",
  },
  concepts: "カメラコンセプト",
  cameraMovementPreset: {
    icon: "カメラ操作プリセット",
    description: "クリックでカメラ操作をプロンプトに追加します。",
    title: "カメラ軌道",
    warning: "*モデルにより、カメラ操作が反映されない場合があります。",
    concept: {
      truck_left: "トラック左",
      pan_right: "パン右",
      pedestal_down: "ペデスタルダウン",
      low_angle: "ローアングル",
      pedestal_up: "ペデスタルアップ",
      selfie: "自撮り",
      pan_left: "パン左",
      roll_right: "ロール右",
      zoom_in: "ズームイン",
      over_the_shoulder: "オーバーショルダー",
      orbit_right: "軌道右回り",
      orbit_left: "軌道左回り",
      static: "静止",
      tiny_planet: "タイニープラネット",
      high_angle: "ハイアングル",
      bolt_cam: "ボルトカム",
      dolly_zoom: "ドリーズーム",
      overhead: "頭上",
      zoom_out: "ズームアウト",
      handheld: "ハンドヘルド",
      roll_left: "ロール左",
      pov: "POV",
      aerial_drone: "ドローン空撮",
      push_in: "プッシュイン",
      crane_down: "クレーンダウン",
      truck_right: "トラック右",
      tilt_down: "チルトダウン",
      elevator_doors: "エレベータードア",
      tilt_up: "チルトアップ",
      ground_level: "グラウンドレベル",
      pull_out: "プルアウト",
      aerial: "空撮",
      crane_up: "クレーンアップ",
      eye_level: "アイレベル",
    },
    icon_concept: "カメラコンセプト",
    title_concept: "カメラコンセプト",
    warning_concept: "*2つまで選択可能ですが、破綻や不自然な動きが発生する場合があるため、1つの選択を推奨。",
    no_concepts_selected: "選択されていません",
    movement: {
      // Ray2 movements
      panleft: "左パン",
      panright: "右パン",
      orbitleft: "オービットレフト",
      orbitright: "オービットライト",
      craneup: "クレーンアップ",
      cranedown: "クレーンダウン",
      moveleft: "左移動",
      moveright: "右移動",
      moveup: "上移動",
      movedown: "下移動",
      pushin: "プッシュイン",
      pullout: "プルアウト",

      // Hailuo movements
      leftcirclingshot: "左回り込み",
      rightcirclingshot: "右回り込み",
      leftwalkingshot: "左歩き",
      rightwalkingshot: "右歩き",
      upwardtilt: "上向き傾け前進",
      downwardtilt: "下降上向き傾け",
      scenicshot: "風景ショット",
      stageshotright: "右パンズームイン",
      stageshotleft: "左パンズームイン",
      zoomin: "ズームイン",
      zoomout: "ズームアウト",
      tiltup: "チルトアップ",
      tiltdown: "チルトダウン",
      truckleft: "左トラック",
      truckright: "右トラック",
      pedestalup: "ペデスタルアップ",
      pedestaldown: "ペデスタルダウン",
      trackingshot: "トラッキングショット",
      shake: "シェイク",
      staticshot: "静止ショット",
    },
  },
};
export default junoVideo;
